import {useQuery} from '@tanstack/react-query';
import {BROKERAGES_QUERY_KEY} from 'App/data-hooks/queryKeys';
import {getCustomerMileageExceptions} from 'App/api/brokers';

function useCustomerMileageExceptions(brokerageId, options = {}) {
  return useQuery([BROKERAGES_QUERY_KEY, brokerageId], () => getCustomerMileageExceptions(brokerageId), options);
}

export default useCustomerMileageExceptions;
